"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerBase = void 0;
var utils_1 = require("./utils");
var TrackerBase = /** @class */ (function () {
    function TrackerBase(handler, options) {
        var _a, _b, _c;
        (_a = __assign(__assign({}, utils_1.DEFAULT_OPTIONS), options), _b = _a.createNewBlockOrUseExistingOneError, this.createNewBlockOrUseExistingOneError = _b === void 0 ? 'createNewBlockOrUseExistingOneToUploadFilesError' : _b, _c = _a.allowedContentType, this.allowedContentType = _c === void 0 ? 'all' : _c);
        this.handler = handler;
    }
    TrackerBase.prototype.uploadFiles = function (files) {
        var _a = (0, utils_1.getFilteredFileTypes)(files.slice(0, utils_1.MAX_FILES_LENGTH_FOR_NEW_BLOCK), this.allowedContentType), allowed = _a.allowed, forbidden = _a.forbidden;
        forbidden.forEach(function (_a) {
            var name = _a.name;
            (0, utils_1.invalidFileFormatError)(name);
        });
        if (files.length > utils_1.MAX_FILES_LENGTH_FOR_NEW_BLOCK) {
            (0, utils_1.uploadOverTenFilesIsForbiddenError)();
        }
        this.handler(allowed.length ? allowed : null);
    };
    TrackerBase.prototype.uploadFile = function (files) {
        var _a = (0, utils_1.getFilteredFileTypes)(files.slice(0, utils_1.MAX_FILES_LENGTH_FOR_EXISTING_BLOCK), this.allowedContentType), allowed = _a.allowed, forbidden = _a.forbidden;
        if (files.length > 1) {
            (0, utils_1.canOnlyReplaceOneFileError)();
        }
        forbidden.forEach(function (_a) {
            var name = _a.name;
            (0, utils_1.invalidFileFormatError)(name);
        });
        return this.handler(allowed.length ? [allowed[0]] : null);
    };
    TrackerBase.prototype.uploadHandler = function (files) {
        if (this.allowedContentType === 'all') {
            this.uploadFiles(files);
        }
        else {
            this.uploadFile(files);
        }
    };
    return TrackerBase;
}());
exports.TrackerBase = TrackerBase;
